const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignWidgetIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.998,
    height: 20,
    viewBox: "0 0 17.998 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13806",
    d: "M213.021 118.508a3.83 3.83 0 1 0-5.416-5.416l-7.722 7.726a3.642 3.642 0 0 0-1.073 2.59v3.9h3.9a3.643 3.643 0 0 0 2.593-1.073zM202.7 125.3h-1.9v-1.9a1.667 1.667 0 0 1 .487-1.18l7.726-7.72a1.83 1.83 0 0 1 2.587 2.586l-7.726 7.722a1.666 1.666 0 0 1-1.176.487z",
    transform: "translate(-198.808 -111.97)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13807",
    d: "M198.8 414.4h18v2h-18z",
    transform: "translate(-198.8 -396.4)",
    style: {
      fill: "#333"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignWidgetIcon);
export default __webpack_public_path__ + "static/media/sign-widget-icon.e99023b3d5c78b511d92a5eecd7b904f.svg";
export { ForwardRef as ReactComponent };